import React from "react";

const CLIENT_LOGOS = [
  { image: "/assets/client/1.png", name: "Client 1" },
  { image: "/assets/client/2.png", name: "Client 2" },
  { image: "/assets/client/3.png", name: "Client 3" },
  { image: "/assets/client/4.png", name: "Client 4" },
  { image: "/assets/client/5.png", name: "Client 5" },
  { image: "/assets/client/6.png", name: "Client 6" },
  { image: "/assets/client/7.png", name: "Client 7" },
  { image: "/assets/client/8.png", name: "Client 8" },
  { image: "/assets/client/9.png", name: "Client 9" },
  { image: "/assets/client/10.png", name: "Client 10" },
  { image: "/assets/client/11.png", name: "Client 11" },
  { image: "/assets/client/12.png", name: "Client 12" },
  { image: "/assets/client/13.png", name: "Client 13" },
  { image: "/assets/client/14.png", name: "Client 14" },
  { image: "/assets/client/15.png", name: "Client 15" },
  { image: "/assets/client/16.png", name: "Client 16" },
  { image: "/assets/client/17.png", name: "Client 17" },
  { image: "/assets/client/18.png", name: "Client 18" },
  { image: "/assets/client/19.png", name: "Client 19" },
  { image: "/assets/client/20.png", name: "Client 20" },
  { image: "/assets/client/21.png", name: "Client 21" },
  { image: "/assets/client/22.png", name: "Client 22" },
  { image: "/assets/client/23.png", name: "Client 23" },
  { image: "/assets/client/24.png", name: "Client 24" },
  { image: "/assets/client/25.png", name: "Client 25" },
  { image: "/assets/client/26.png", name: "Client 26" },
  { image: "/assets/client/27.png", name: "Client 27" },
  { image: "/assets/client/28.png", name: "Client 28" },
];

// Split into two balanced bands for visual flow
const band1Logos = CLIENT_LOGOS.filter((_, i) => i % 2 === 0); // Even indices
const band2Logos = CLIENT_LOGOS.filter((_, i) => i % 2 === 1); // Odd indices

// Duplicate for seamless infinite loop
const duplicatedBand1 = [...band1Logos, ...band1Logos];
const duplicatedBand2 = [...band2Logos, ...band2Logos];

const TrustedClients = () => {
  return (
    <section className="py-24 lg:py-32 relative overflow-hidden bg-gradient-to-br from-[#2642B2] via-indigo-900 to-slate-900 text-whiten">
      {/* Ambient glows */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-0 w-96 h-96 bg-indigo-800 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-800 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      </div>

      {/* Heading */}
      <div className="container mx-auto px-6 relative z-20 mb-20">
        <div className="text-center max-w-4xl mx-auto">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-8 leading-tight drop-shadow-2xl">
            Trusted Clients
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Partnering with leading organizations worldwide
          </p>
        </div>
      </div>

      {/* Parallel Bands Scrolling Logos */}
      <div className="relative z-10 mb-20">
        {/* Top Band - Left to Right */}
        <div className="band band-top mb-8">
          <div className="band-track">
            {duplicatedBand1.map((client, i) => (
              <div key={`top-${i}`} className="band-logo">
                <img
                  src={client.image}
                  alt={client.name}
                  className="max-w-full max-h-full object-contain filter transition-all duration-500"
                  loading="lazy"
                  onError={(e) => (e.currentTarget.style.opacity = "0.3")}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Band - Right to Left */}
        <div className="band band-bottom">
          <div className="band-track">
            {duplicatedBand2.map((client, i) => (
              <div key={`bottom-${i}`} className="band-logo">
                <img
                  src={client.image}
                  alt={client.name}
                  className="max-w-full max-h-full object-contain filter transition-all duration-500"
                  loading="lazy"
                  onError={(e) => (e.currentTarget.style.opacity = "0.3")}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Text + Stats + CTA */}
      <div className="container mx-auto px-6 relative z-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 max-w-6xl mx-auto items-center">
          {/* Left: Text */}
          <div className="text-center lg:text-left">
            <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 drop-shadow-lg">
              Global Partners
            </h3>
            <p className="text-xl text-gray-200 leading-relaxed max-w-lg">
              Trusted by industry leaders across 20+ countries
            </p>
          </div>

          {/* Right: Stats */}
          <div className="grid grid-cols-2 gap-6 max-w-md mx-auto lg:mx-0">
            {[
              { value: "28+", label: "Clients" },
              { value: "500+", label: "Projects" },
              // { value: "98%", label: "Success Rate" },
            ].map((stat, i) => (
              <div
                key={i}
                className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-8 text-center shadow-2xl hover:bg-white/10 hover:scale-105 transition-all duration-500"
              >
                <div className="text-4xl md:text-5xl font-bold text-cyan-400 mb-2">
                  {stat.value}
                </div>
                <div className="text-lg text-gray-200 font-semibold">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center mt-16">
          <button className="inline-flex items-center gap-3 bg-gradient-to-r from-cyan-500 to-purple-600  px-10 py-5 rounded-full text-xl font-bold text-white shadow-2xl hover:shadow-indigo-500/50 hover:scale-105 transition-all duration-500">
            Get in Touch
            <span className="text-2xl">→</span>
          </button>
        </div>
      </div>

      {/* Parallel Bands CSS */}
      <style jsx>{`
        .band {
          width: 100%;
          overflow: hidden;
          position: relative;
          white-space: nowrap;
        }

        .band-track {
          display: inline-flex;
          gap: 10px; /* Decreased from 80px */
          padding: 10px 0; /* Increased padding for larger logos */
          width: max-content;
          will-change: transform;
        }

        .band-top .band-track {
          animation: slideLeftToRight 35s linear infinite; /* Slightly faster */
        }

        .band-bottom .band-track {
          animation: slideRightToLeft 35s linear infinite; /* Slightly faster */
        }

        .band-logo {
          flex-shrink: 0;
          width: 220px; /* Increased from 180px */
          height: 130px; /* Increased from 100px */
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 15px; /* Increased from 10px */
          transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
        }

        .band-logo:hover {
          transform: scale(1.2) translateY(-8px); /* Increased hover effect */
          box-shadow: 0 15px 40px rgba(99, 102, 241, 0.3); /* Enhanced shadow */
          z-index: 10;
        }

        @keyframes slideLeftToRight {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        @keyframes slideRightToLeft {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }

        .band:hover .band-track {
          animation-play-state: paused;
        }

        /* Responsive - Adjusted for larger logos */
        @media (max-width: 1280px) {
          .band-logo { width: 200px; height: 120px; }
          .band-track { gap: 35px; }
        }

        @media (max-width: 1024px) {
          .band-logo { width: 180px; height: 110px; padding: 12px; }
          .band-track { gap: 30px; }
        }

        @media (max-width: 768px) {
          .band-logo { width: 150px; height: 90px; padding: 10px; }
          .band-track { gap: 25px; padding: 40px 0; }
        }

        @media (max-width: 640px) {
          .band-logo { width: 130px; height: 80px; padding: 8px; }
          .band-track { gap: 20px; padding: 35px 0; }
        }
      `}</style>
    </section>
  );
};

export default TrustedClients;